module.exports = __webpack_public_path__ + "static/media/s3-bottom-left-4.a909a5bb.png";